<div class="page-wrapper">
  <div class="page-sidebar">
    <!-- sidebar content -->
  </div>
  <div class="page-content">
    <h1 l10nTranslate>core.reqAccess</h1>
    <ng-container *ngTemplateOutlet="isRequestSent ? requestSent : sendRequest"></ng-container>
    <miq-footer></miq-footer>
  </div>
</div>
<ng-template #requestSent>
  <div class="request-sent">
    <span><strong l10nTranslate>core.thankyouMsg</strong></span>
    <p l10nTranslate>core.reqAccessDesc</p>
    <div class="flt-right">
      <button mat-flat-button color="primary" (click)="requestAgain()" l10nTranslate>core.requestAgain</button>
    </div>
  </div>
</ng-template>
<ng-template #sendRequest>
  <div class="message-request">
    <span>
      <strong>
        {{('core.hi' | xTranslate) + ' ' + userName + ' ' + ('core.welcomeTo' | xTranslate) + ' ' + appName +' ' +
        ('core.noAccess' | xTranslate)}}
      </strong>
    </span>
    <p>
      {{'core.useScreen' | xTranslate}}
      <br />
      {{'core.reqProcessed' | xTranslate}}
      <span class="warning">
        {{'core.usWarningMessage' | xTranslate}}
        <a [href]="cepHost">{{cepHost}}</a></span
      >
    </p>
  </div>

  <form class="access-needed" [formGroup]="accessFormGroup">
    <div class="roles">
      <span>{{'core.role' | xTranslate | titlecase }}</span>
      <mat-form-field appearance="outline">
        <mat-select
          hideSingleSelectionIndicator="true"
          placeholder="{{'core.roles' | xTranslate}}"
          [formControl]="role"
          required
          disableOptionCentering
        >
          <mat-option *ngFor="let roleOption of roleOptions" [value]="roleOption.key">
            {{roleOption.value}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="userTypes">
      <span>{{'core.userTypes' | xTranslate | titlecase }}</span>
      <mat-radio-group [formControl]="userType" required>
        <mat-radio-button [value]="userTypeOption.key" *ngFor="let userTypeOption of userTypeOptions">
          {{userTypeOption.value}}
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="country">
      <span>{{'core.country' | xTranslate | titlecase }}</span>
      <mat-form-field appearance="outline">
        <mat-select
          hideSingleSelectionIndicator="true"
          placeholder="{{'core.countries' | xTranslate}}"
          [formControl]="country"
          required
          disableOptionCentering
        >
          <mat-option *ngFor="let country of countryOptions" [value]="country.key"> {{country.value}} </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>

  <miq-location-permissions
    [locationPermissions]="locationPermissions"
    [pageType]="'user'"
    [requestMode]="'true'"
    (formReady)="addFormControl($event)"
  >
  </miq-location-permissions>

  <div class="flt-right">
    <button mat-button color="primary" (click)="resetData()" l10nTranslate>core.reset</button>
    <button mat-flat-button color="primary" (click)="submitRequest()" [disabled]="disabledSubmitButton" l10nTranslate>
      core.submit
    </button>
  </div>
</ng-template>
